/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { isInvalid } from 'redux-form';

export const getFormIsInvalidWaySelector = () =>
	createSelector(isInvalid('orders-change-way-modal'), isInvalid => isInvalid);
